import React from 'react';
import UploadPhotoRhf from '../../../ReactHookForm/UploadPhotoRhf/UploadPhotoRhf';
import { Divider, Grid } from '@material-ui/core';
import TextFieldRhf from '../../../ReactHookForm/TextFieldRhf/TextFieldRhf';
import { ErrorMessage } from '@hookform/error-message';
import RadioRhf from '../../../ReactHookForm/RadioRhf/RadioRhf';
import { RadioOptionRhf } from '../../../ReactHookForm/RadioRhf/RadioOptionRhf';
import RetrackInputRhf from '../RetrackReport/components/RetrackInputRhf/RetrackInputRhf';

export const loopRetrackReportQuestions = (
    retrackReportQuestions,
    direction = 'Upper',
    readOnly = false,
    get = undefined
) => {
    return Object.keys(retrackReportQuestions).map((key) => {
        const value = retrackReportQuestions[key];
        switch (value.component) {
            case 'ArchToTreatRhf':
                return (
                    <Grid item xs={12} sm={12} style={{ display: 'flex' }}>
                        <RadioRhf
                            key={value.name}
                            question={value?.question}
                            name={value.name}
                            defaultValue={value.defaultValue}
                            formControlLabelRhf={value.option.map((v) => (
                                <RadioOptionRhf
                                    key={v.value}
                                    value={v.value}
                                    label={v.label}
                                    disable={readOnly ? readOnly : value?.disable}
                                />
                            ))}
                            ImageComponent={value?.imageComponent}
                        />
                    </Grid>
                );
            case 'LeftTextFieldRhf':
                return (
                    <Grid item xs={12} sm={6} style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{ fontWeight: 600, paddingRight: 8 }}>
                            {get(`@PatientInfo.retrackReport.${value.label}`)}:{' '}
                        </div>
                        <RetrackInputRhf name={value.name} readOnly={true} />
                    </Grid>
                );
            case 'RightTextFieldRhf':
                return (
                    <Grid
                        item
                        xs={12}
                        sm={6}
                        style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}
                    >
                        <div style={{ fontWeight: 600, paddingRight: 8 }}>
                            {get(`@PatientInfo.retrackReport.${value.label}`)}:{' '}
                        </div>
                        <RetrackInputRhf name={value.name} textFieldStyle={{ width: '100px' }} readOnly={true} />
                    </Grid>
                );
            case 'UploadPhotoRhf':
                return (
                    <Grid item xs={12} sm={6}>
                        <UploadPhotoRhf key={value.name} name={value.name} label={value.label} readOnly={readOnly} />
                    </Grid>
                );
            case 'AlignerStepRhf':
                return (
                    <>
                        <Grid item xs={12} style={{ marginBottom: 8 }}>
                            <div style={{ textAlign: 'center', fontWeight: 600, fontSize: 40 }}>{direction}</div>
                        </Grid>
                        <Grid container alignItems="center" style={{ marginBottom: 8 }}>
                            <Grid item xs={6} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <div style={{ fontWeight: 600 }}>
                                    <div>{get(`@PatientInfo.retrackReport.${value.label.alignerStep}`)}</div>
                                    <div style={{ textAlign: 'end' }}>
                                        ({get(`@PatientInfo.retrackReport.${value.label.alignerStepComparison}`)}):
                                    </div>
                                </div>
                            </Grid>
                            <Grid item xs={6} style={{ paddingLeft: 48, fontSize: 25 }}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <div>(</div>
                                    <RetrackInputRhf
                                        name={value.name}
                                        showError={false}
                                        readOnly={readOnly}
                                        fontSize="40px"
                                        color="gray"
                                        readColor="gray"
                                        readFontSize="40px"
                                        width="100px"
                                    />
                                    <div>)</div>
                                    <ErrorMessage
                                        name={value.name}
                                        render={({ message }) => (
                                            <div style={{ color: 'red', fontSize: 16, paddingLeft: 16 }}>{message}</div>
                                        )}
                                    />
                                </div>
                            </Grid>
                        </Grid>
                    </>
                );
            case 'NewScanRhf':
                return (
                    <Grid container alignItems="center">
                        <Grid item xs={6} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <div style={{ fontWeight: 600 }}>
                                {get(`@PatientInfo.retrackReport.${value.label.newScan}`)}:
                            </div>
                        </Grid>
                        <Grid item xs={6} style={{ paddingLeft: 48, fontSize: 25 }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <div>(</div>
                                <RetrackInputRhf
                                    name={value.name}
                                    width="100px"
                                    readFontSize="40px"
                                    fontSize="40px"
                                    color="blue"
                                    showError={false}
                                    readOnly={readOnly}
                                />
                                <div>)</div>
                                <ErrorMessage
                                    name={value.name}
                                    render={({ message }) => (
                                        <div style={{ color: 'red', fontSize: 16, paddingLeft: 16 }}>{message}</div>
                                    )}
                                />
                            </div>
                        </Grid>
                        <Grid item style={{ display: 'flex', marginTop: 16, fontWeight: 'bold' }} xs={12}>
                            <div style={{ color: 'green', paddingRight: 8 }}>
                                {get(`@PatientInfo.retrackReport.${value.label.greenText}`)}
                            </div>
                            <div style={{ color: 'lightpink' }}>
                                {get(`@PatientInfo.retrackReport.${value.label.pinkText}`)}
                            </div>
                        </Grid>
                    </Grid>
                );
            // case 'ClosestMatchAlignerStepRhf':
            //     return (
            //         <Grid item style={{ display: 'flex', alignItems: 'center' }} xs={12} >
            //             <div style={{ paddingRight: 16, fontWeight: 'bold' }}>
            //                 {get(`@PatientInfo.retrackReport.newScanApprovedTreatment`)}:
            //             </div>
            //             <div style={{ paddingRight: 16, fontWeight: 'bold' }}>
            //                 {get(`@PatientInfo.retrackReport.newScanApprovedTreatmentStep`)}
            //             </div>
            //             <div style={{ fontWeight: 'bold', paddingRight: 8, }}>(</div>
            //             <RetrackInputRhf name={value.name} width='60px' showError={false} readOnly={readOnly} />
            //             <div style={{ fontWeight: 'bold', paddingRight: 8, }}>)</div>
            //             <ErrorMessage
            //                 name={value.name}
            //                 render={({ message }) => <div style={{ color: 'red', fontSize: 16, paddingLeft: 16 }}>{message}</div>}
            //             />
            //         </Grid>
            //     );
            // case 'AlignerStepSentToClinic':
            //     return (
            //         <Grid item style={{ display: 'flex' }} xs={12} >
            //             {value.option.map((option, i) => {
            //                 if (i === 0) {
            //                     return (
            //                         <>
            //                             <div style={{ paddingRight: 8, fontWeight: 'bold' }}>
            //                                 {get(`@PatientInfo.retrackReport.sentToClinicTherefore`)}
            //                             </div>
            //                             <div style={{ paddingRight: 8, fontWeight: 'bold' }}>(</div>
            //                             <RetrackInputRhf name={option.name} width='60px' readOnly={readOnly} />
            //                             <div style={{ paddingRight: 8, fontWeight: 'bold' }}>)</div>
            //                         </>
            //                     )
            //                 }

            //                 if (i === 1) {
            //                     return (
            //                         <>
            //                             <div style={{ paddingRight: 8, fontWeight: 'bold' }}>{get(`@PatientInfo.retrackReport.sentToClinicTo`)}</div>
            //                             <div style={{ paddingRight: 8, fontWeight: 'bold' }}>(</div>
            //                             <RetrackInputRhf name={option.name} width='60px' readOnly={readOnly} />
            //                             <div style={{ paddingRight: 8, fontWeight: 'bold' }}>)</div>
            //                             <div style={{ paddingRight: 8, fontWeight: 'bold' }}>
            //                                 {get(`@PatientInfo.retrackReport.sentToClinic`)}
            //                             </div>
            //                         </>
            //                     )
            //                 }
            //             })}
            //         </Grid>
            //     );
            default:
                return null;
        }
    });
};
